import queryString from 'query-string';
import { PureComponent } from 'react';

import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import allowRedirect from 'utils/allowRedirect';
import { trackPageView } from 'utils/analytics/track/trackPageView';
import { isPathOnlyUrl } from 'utils/isPathOnlyUrl';
import { setDocumentTitle } from 'utils/meta/setDocumentTitle';
import { RouteComponentProps, withRouter } from 'utils/withRouter';

import { LoginPage } from './LoginPage';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type OwnProps = {};
type Props = OwnProps &
  RouteComponentProps<{
    savedListing?: { id: string; type: string; name: string };
    subscribedSubsite?: string;
    title?: string;
    inviteId: string;
    email?: string;
    redirectTo?: string;
  }>;

class LoginPageContainer extends PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/destructuring-assignment
  queryParams = queryString.parse(this.props.location.search);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/sort-comp
  get savedListing() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
    return this.props.location.state && this.props.location.state.savedListing;
  }

  get subscribedSubsite() {
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
      this.props.location.state && this.props.location.state.subscribedSubsite
    );
  }

  get title() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
    return this.props.location.state && this.props.location.state.title;
  }

  get inviteId() {
    return (
      (this.queryParams.invite as string) || // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
      (this.props.location.state && this.props.location.state.inviteId)
    );
  }

  get email() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
    return this.props.location.state && this.props.location.state.email;
  }

  get redirectTo() {
    return (
      (this.queryParams.to as string) || // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, react/destructuring-assignment
      (this.props.location.state && this.props.location.state.redirectTo)
    );
  }

  componentDidMount() {
    trackPageView('Login', {
      page_type: 'Login',
    });
    setDocumentTitle(getText('Log In'));
  }

  redirect = (user: ApiUser) => {
    let redirectTo = null;

    if (this.inviteId) {
      redirectTo = `/user-invites/${this.inviteId}`;
    } else {
      redirectTo = this.redirectTo;
    }

    if (!redirectTo || !allowRedirect(redirectTo)) {
      redirectTo = `/${user.locale}/`;
    }

    if (user.locale !== CURRENT_LOCALE) {
      const regexp = new RegExp(`^/${CURRENT_LOCALE}`);
      redirectTo = redirectTo.replace(regexp, `/${user.locale}`);
      window.location.assign(redirectTo);
    }

    if (!isPathOnlyUrl(redirectTo)) {
      window.location.assign(redirectTo);
      return;
    }

    // TODO: route relative urls with react-router once all pages have been redesigned
    window.location.assign(redirectTo); // this.props.history.push(redirectTo);
  };

  render() {
    return (
      <LoginPage
        onLogin={this.redirect}
        redirectTo={this.redirectTo}
        email={this.email}
        inviteId={this.inviteId}
        savedListing={this.savedListing}
        subscribedSubsite={this.subscribedSubsite}
        title={this.title}
      />
    );
  }
}

export default withRouter(LoginPageContainer);
